<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-28 19:48:07
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-04-25 15:42:17
 * @FilePath: \ioc_base\src\common\view\HomeNew.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <transition>
    <div class="home-page">
      <!-- 小菜单 -->
      <el-carousel
        trigger="click"
        :autoplay="false"
        indicator-position="none"
        :initial-index="checkBtnIndex"
        arrow="never"
        style="height: 80%"
        ref="refCarousel"
      >
        <el-carousel-item
          v-for="(i, j) in menuList"
          :key="'menu' + j"
          :name="i.label"
          style="height: 100%"
        >
          <div class="page-main">
            <el-row
              :gutter="24"
              style="height: 100%; margin-left: -8px; margin-right: 8px"
            >
              <el-col
                :span="8"
                style="padding: 0 8px; height: 50%"
                v-for="(item, index) in menuTwoList[i.value]"
                :key="'menuTwo' + index"
              >
                <el-card shadow="hover" class="menuTwo" v-if="item.label">
                  <!-- 二级菜单 -->
                  <div class="fontStyles">
                    <!-- <i class="iconfont-lunan icon-lunan-lujing4"></i> -->
                    <span>
                      {{ item.label }}
                    </span>
                  </div>
                  <!-- 三级菜单 -->
                  <div
                    :class="['menuList', item.rowReverse ? 'flexReverse' : '']"
                    v-if="item.layoutType == 3"
                  >
                    <!-- 三宫格 -->
                    <div class="layoutThree">
                      <img
                        class="menuImg"
                        alt=""
                        @click="showViewer(item.placeholderUrl)"
                        :src="item.placeholderUrl"
                      />
                    </div>
                    <div class="layoutThree">
                      <div
                        class="menuItem"
                        v-for="(children, k) in item.children"
                        @click="goMenu(children)"
                        :key="'menuItem' + k"
                      >
                        <img
                          class="menuIcon"
                          @click.stop="showViewer(children.menuIcon)"
                          :src="queryImg(children.label)"
                          alt=""
                        />
                        <span style="line-height: 24px; position: relative">
                          {{ children.label }}
                          <span class="menuNum" v-if="children.total">{{
                            children.total > 99 ? "99+" : children.total
                          }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- 四宫格 -->
                  <div class="menuList" v-else>
                    <div v-if="item.slotTop" class="menuItem menuSlot"></div>
                    <div
                      class="menuItem"
                      v-for="(children, k) in item.children"
                      :key="'menuItems' + k"
                      @click="goMenu(children)"
                    >
                      <!-- 展示菜单img -->
                      <img
                        v-if="children.type == 'img'"
                        class="menuImg"
                        :src="children.bgUrl"
                        @click.stop="showViewer(children.bgUrl)"
                        alt=""
                      />
                      <!-- 展示菜单icon -->
                      <img
                        v-else
                        class="menuIcon"
                        alt=""
                        :src="queryImg(children.label)"
                      />
                      <!-- :src="children.menuIcon" -->
                      <span style="line-height: 20px; position: relative">
                        {{ children.label }}
                        <span class="menuNum" v-if="children.total">{{
                          children.total > 99 ? "99+" : children.total
                        }}</span>
                      </span>
                    </div>
                    <div v-if="item.slotBottom" class="menuItem menuSlot">
                      <img alt="" class="menuImg" :src="item.slotBottomImg" @click.stop="showViewer(item.slotBottomImg)" />
                      <!-- <div
                        v-for="(slotItem, slotIndex) in item.slotData"
                        :key="'slot' + slotIndex"
                        class="flexStyle"
                      >
                        <img class="menuIcon" :src="slotItem.icon" alt="" />
                        <div style="text-align: center; line-height: 24px">
                          <div
                            :style="{ color: slotItem.color }"
                            style="font-size: 18px"
                          >
                            {{ slotItem.total }}
                          </div>
                          <div>
                            {{ slotItem.label }}
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </el-card>
                <el-card v-else class="menuTwo">
                  <div class="menuList">
                    <img
                      :src="item.noneMenuUrl"
                      @click="showViewer(item.noneMenuUrl)"
                      class="menuImg"
                      alt=""
                    />
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </el-carousel-item>
      </el-carousel>

      <!-- 大菜单 -->
      <div class="page-footer">
        <div
          v-for="(item, index) in menuList"
          :key="item.value"
          :class="['menuBtn', checkBtnIndex == index ? 'highStyle' : '']"
          @click="checkMenu(item, index)"
        >
          <div class="btnImg">
            <img :src="checkBtnIndex == index ? item.iconActive : item.icon" alt="" />
          </div>
          <div class="btnName">{{ item.label }}</div>
        </div>
      </div>
      <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
        <img v-for="src in viewerPhotos" :src="src" :key="src" />
      </viewer>
    </div>
  </transition>
</template>

<script>
import menuData from "@src/common/config/menuList";
import eventBus from "@src/common/utils/eventBus";
import eventConfig from "@src/common/config/eventConfig";
export default {
  data() {
    return {
      soundMenuList: [], // JSON.parse(sessionStorage.getItem("sessionMenuData")),
      soundMenuMap: [], // JSON.parse(sessionStorage.getItem("sessionMenuMap")),
      viewerInstance: null,
      viewerPhotos: [],
      checkBtnIndex: Number(sessionStorage.getItem("HomeIndex")) || 0,
      menuTwoList: menuData.menuTwoList,
      menuList: menuData.menuList,
      imagesContext: [],
    };
  },
  created() {
    this.imagesContext = require.context(
      "@src/common/assets/images/homeMenu",
      false,
      /\.png$/
    );
  },
  mounted() {},
  methods: {
    getMenu() {
      return {
        soundMenuList: JSON.parse(sessionStorage.getItem("sessionMenuData")),
        soundMenuMap: JSON.parse(sessionStorage.getItem("sessionMenuMap")),
      };
    },
    queryImg(info) {
      let url = "./" + info + ".png";
      let menuIcon = "";
      this.imagesContext.keys().forEach((el) => {
        if (el === url) {
          menuIcon = this.imagesContext(url);
        }
      });
      return menuIcon;
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(imgs, e) {
      this.viewerPhotos = [imgs];
      this.viewerInstance.show();
    },
    checkMenu(item, index) {
      this.soundMenuList = this.getMenu().soundMenuList;
      if (!this.soundMenuList) {
        return this.$message.warning("对不起！你暂无访问权限");
      }
      const isAuth = this.soundMenuList.twoMenu.some((el) => {
        return el.menuCode == item.menuCode;
      });
      if (!isAuth) {
        return this.$message.warning("对不起！你暂无访问权限");
      }
      this.checkBtnIndex = index;
      this.$refs.refCarousel.setActiveItem(item.label);
    },
    goMenu(item) {
      if (!this.getMenu().soundMenuList) {
        return this.$message.warning("对不起！你暂无访问权限");
      }
      if (!item.path) {
        return this.$message.warning("对不起！你暂无访问权限");
      }
      this.sessionMenuMap = this.getMenu().soundMenuMap;
      let isRouterAuth = null;
      for (let i in this.sessionMenuMap) {
        if (this.sessionMenuMap[i].path == item.path) {
          isRouterAuth = this.sessionMenuMap[i];
        }
      }
      if (!isRouterAuth) {
        return this.$message.warning("对不起！你暂无访问权限");
      }
      this.$router.push({ path: isRouterAuth.path });
      eventBus.emit(eventConfig.MENU_CLICK, isRouterAuth);
    },
  },
  beforeDestroy() {
    sessionStorage.setItem("HomeIndex", this.checkBtnIndex);
  },
};
</script>
<style lang="scss" scoped>
:deep .el-carousel__container {
  height: 100% !important;
}
:deep .el-card__body {
  padding: 0px;
  height: 100%;
}
.el-card {
  border: none;
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.flexStyle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flexReverse {
  flex-direction: row-reverse;
}
.fontStyle {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #e8eaee;
}
.fontStyles {
  height: 18px;
  line-height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  @include set_theme_color(color, font-default-color);
}
.fontStyleBtn {
  width: 48px;
  height: 12px;
  line-height: 12px;
  font-size: 12px;
  font-family: Segoe UI-Regular, Segoe UI;
  font-weight: 400;
  color: #707070;
}
.highStyle {
  .btnName {
    // color: #7367f0;
    color: #407aee;
  }
  .btnImg {
    border: 2px solid #407aee !important;
    box-shadow: -1px -1px 5px #407aee, 1px 1px 5px #407aee;
  }
}

.home-page {
  @extend .fontStyle;
  width: 100%;
  padding: 0px 16px 0px;
  .page-main {
    height: 100%;
    width: calc(100% + 16px);
  }
  .page-footer {
    height: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.menuTwo {
  @extend .fontStyle;
  height: calc(100% - 16px);
  padding: 12px 16px 16px;
  @include set_theme_color(background-color, main-content-bg-color);
}

.menuList {
  height: calc(100% - 10px);
  margin-top: 9px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
}
.layoutThree {
  height: calc(100% - 16px);
  width: calc(50% - 8px);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .menuItem {
    width: 100%;
    height: calc(50% - 8px);
    // padding: 0px !important;
  }
}
.menuSlot {
  width: 100% !important;
  justify-content: space-around !important;
}
.menuImg {
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px #7367f0;
  }
}
.menuItem {
  @extend .fontStyle;
  width: calc(50% - 8px);
  height: calc(50% - 16px);
  border-radius: 5px;
  padding: 10px;
  @include set_theme_color(background-color, button-content-bg-color);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    box-shadow: -1px -1px 5px #7367f0, 1px 1px 5px rgba(46,134,232,1);
  }

  .menuIcon {
    // width: 36px;
    // height: 40px;
    margin-right: 8px;
  }
  .menuNum {
    min-width: 17px;
    height: 17px;
    line-height: 16px;
    font-size: 10px;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    text-align: center;
    position: absolute;
    top: -10px;
    // left: -5px;
    // padding: 1px 2px;
    background: #ee1818;
    box-shadow: 0px 3px 6px 0px rgba(115, 103, 240, 0.1608);
    border-radius: 8px 8px 8px 8px;
  }
}
.menuBtn {
  cursor: pointer;
  margin: 0 12px;
  text-align: center;

  &:hover {
    @extend .highStyle;
  }
  .btnName {
    margin-top: 10px;
    @extend .fontStyleBtn;
  }
  .btnImg {
    border: 2px solid #e8eaee;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    // line-height: 62px;
    img {
      width: 26px;
      height: 26px;
    }
  }
}
</style>
